import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import { Images } from '../../assets';
import { useLocation } from 'react-router-dom';
import Exported from '../../service/endpoints';
import request from '../../service';
import ExternalNavbar from './components/ExternalNavbar';
import { Toast } from '../../service/toast';

const ExternalPage = () => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const location = useLocation();
    const pathName = location.pathname;

    const contentIdMap = {
        "/about-us": 1,
        "/privacy-and-security": 2,
        "/terms-and-conditions": 3,
    };

    const pageNameMap = {
        "/about-us": "About Us",
        "/privacy-and-security": "Privacy and Security",
        "/terms-and-conditions": "Terms and Conditions",
    };

    const contentId = contentIdMap[pathName] || null;
    const pageName = pageNameMap[pathName] || "Page";

    const getContentValues = () => {
        request({
            url: `${Exported.Endpoints.content}?content_type=${contentId}`,
            method: Exported.APIMethods.GET,
        }).then((res) => {
            console.log(res, "res")
            const content = res?.data?.data?.description || "";
            setTitle(res?.data?.data?.title || "-")
            setDescription(content || "")

        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    useEffect(() => {
        getContentValues();
    }, [pathName]);

    return (
        <div className="flex flex-col bg-white h-screen">
            <ExternalNavbar />
            <div className={`${classes.titleDiv}`}>
                <p className={`${classes.title} text-xl md:text-3xl lg:text-4xl`}>
                    {pageName}
                </p>
            </div>

            <div className={`${classes.mainDiv} flex-1 overflow-y-auto`}>
                <div className="container mx-auto px-4 py-6">
                    <div className={`${classes.header}`}>
                        <h2 className="">{title}</h2>
                    </div>

                    <div className={`${classes.header} mb-4`}>
                        <div
                            className={`${classes.description} text-base md:text-lg`}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    </div>

                    <div className="flex justify-center mt-8 bg-white">
                        <img
                            src={Images.colorBar}
                            alt="Decorative color bar"
                            className={`${classes.colorBar} bg-white`} 
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );

};

export default ExternalPage;
